<div class="flex items-center justify-between p-4 border-b bg-gray-50/50">
  <p class="text-xl font-bold text-gray-800 flex items-center gap-2">
    <mat-icon class="text-[#025590]">warehouse</mat-icon>
    {{ coverageDetails?.warehouse_name || 'Coverage Intelligence' }} Coverage Summary
  </p>
  <button mat-icon-button (click)="close()" class="text-gray-500">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="p-6">
  <div *ngIf="loading" class="flex flex-col items-center justify-center p-12">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="mt-4 text-sm text-gray-500 font-medium">Loading warehouse data...</p>
  </div>

  <div *ngIf="!loading" class="flex flex-col gap-6">
    
    <div class="bg-white border rounded-xl p-5 shadow-sm">
      <div class="flex justify-between items-start mb-4">
        <div>
          <span class="text-xs font-bold text-gray-400 uppercase tracking-widest">Efficiency Rating</span>
          <div class="text-4xl font-black text-[#025590]">
            {{ coverageDetails?.coverage_ratio }}
          </div>
        </div>
        <div [class]="'px-4 py-1.5 rounded-full text-xs font-black uppercase ' + (coverageDetails?.is_fully_covered ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
          {{ coverageDetails?.coverage_status }}
        </div>
      </div>
      
      <div class="w-full bg-gray-100 rounded-full h-4 mb-2">
        <div class="bg-[#025590] h-4 rounded-full transition-all duration-700 ease-out" 
             [style.width.%]="coverageDetails?.numeric_ratio"></div>
      </div>
      <p class="text-[10px] text-gray-400 uppercase font-bold">Deficit: {{ coverageDetails?.sensor_deficit }} Sensors</p>
    </div>

    <div class="p-4 rounded-xl border border-[#025590]/20 bg-[#025590]/5">
      <div class="flex items-center gap-2 mb-2 text-[#025590]">
        <mat-icon class="scale-90">assignment</mat-icon>
        <span class="text-sm font-bold uppercase tracking-tight">Executive Summary</span>
      </div>
      <p class="text-sm text-gray-700 leading-relaxed">
        {{ coverageDetails?.summary }}
      </p>
    </div>

    <div class="grid grid-cols-2 gap-4">
        <div class="p-3 bg-white border rounded-lg">
            <span class="text-[10px] text-gray-400 font-bold uppercase">Risk Level</span>
            <div class="text-sm font-bold text-red-600">{{ coverageDetails?.interpretation?.risk_level }}</div>
        </div>
        <div class="p-3 bg-white border rounded-lg">
            <span class="text-[10px] text-gray-400 font-bold uppercase">Action Required</span>
            <div class="text-sm font-bold text-[#025590]">{{ coverageDetails?.interpretation?.action_required }}</div>
        </div>
    </div>

    <div class="rounded-xl bg-gray-100 p-4 border border-gray-200 shadow-inner">
      <div class="flex items-center gap-2 text-[#025590] font-bold text-[10px] uppercase mb-3 tracking-widest">
        <mat-icon class="scale-75">analytics</mat-icon> Calculation Logic
      </div>
      <div class="space-y-2">
      <div *ngFor="let step of coverageDetails?.calculation_description | keyvalue" class="text-[11px] font-mono flex gap-2">
    <span class="text-[#025590] font-bold whitespace-nowrap uppercase">{{ step.key }}:</span>
    <span class="text-gray-600">{{ step.value }}</span>
</div>
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-4 bg-gray-50 border-t">
  <button mat-flat-button (click)="close()" class="px-8 py-2 rounded-lg !bg-[#025590] !text-white !font-bold hover:brightness-110">
    CLOSE
  </button>
</mat-dialog-actions>